import axios from "axios"
import type {Router} from 'vue-router'

let router: Router | null = null

function Api() {
}

Api.prototype = axios

// @ts-ignore
Api.prototype.install = function (app: any) {
    const self = this;
    app.plugin = self
    app.config.globalProperties.$api = self
}

export function setRouter(r: Router) {
    router = r
}

export function createApi(args: any) {
    const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000'
    const API_BASE = import.meta.env.VITE_API_BASE || ''
    
    args.handler.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
    args.handler.defaults.headers.common['Content-Type'] = 'application/json'
    args.handler.defaults.baseURL = `${API_URL}/${API_BASE}/`

    args.handler.interceptors.request.use(function (config: any) {
        // config.headers['Authorization'] = 'Bearer ' + authService.getToken()
        return config
    }, function (error: any) {
        return Promise.reject(error)
    })

    args.handler.interceptors.response.use(
        (response: any) => {
            return response
        },
        async (error: any) => {
            const isAuthEndpoint = error.config?.url?.includes('auth/token')

            if (error.response?.status === 401 && !isAuthEndpoint && router) {
                console.log('401 Unauthorized')
                // authService.logout()
                if (router.currentRoute.value.name !== 'login') {
                    await router.push({name: 'login'})
                }
            } else if (error.response.status === 403 && router) {
                console.log('403 Forbidden')
                if (router.currentRoute.value.name !== 'forbidden') {
                    await router.push({name: 'forbidden'})
                }
            }

            return Promise.reject(error)
        }
    )
    // @ts-ignore
    return new Api()
}
